import {required} from 'vuelidate/lib/validators'

/**
 * Model "class" for Metric - defines useful field metadata for building and validating forms
 */

export default {
    fields: {
        metric: {
            label: 'LABEL_METRIC_SELECT',
            type: 'select',
            options: {
                'WEIGHT': 'FIELD_METRIC_WEIGHT',
                'ACTIVITY': 'FIELD_METRIC_STEPS',
            },
            validations: {required},
            invalidFeedback: {required: 'MESSAGE_FIELD_REQUIRED'}
        },
        date: {
            label: 'LABEL_METRIC_DATE',
            type: 'date'
        },
        value: {
            label: 'LABEL_METRIC_VALUE',
            type: 'number'
        }
    }
}
